import type { ApiWriteTour } from '#api/model/types.ts';
import type { TourStop } from '#domain/TourStop.ts';
import { toCapacityWeightKg } from '#domain/tourCapacity.ts';

import { toChargingDraft } from './chargingDrafts.ts';

export type TourFormValues = {
    tourNumber: string;
    note?: string;
    driver: string;
    vehicle: string;
    selectedOrderIds: string[];
    maxWeightT?: number;
    maxLoadingMeter?: number;
    maxVolumeLiter?: number;
    maxVolumeCubicMeter?: number;
};

export const ToBackendDTO = (tour: TourFormValues, stopList: TourStop[], trailerId?: string): ApiWriteTour => {
    return {
        search_name: tour.tourNumber,
        note: tour.note,
        driver_id: tour.driver || undefined,
        truck_id: tour.vehicle,
        trailer_id: trailerId || undefined,
        capacity: {
            max_weight_kg: toCapacityWeightKg(tour.maxWeightT),
            max_loading_meter: tour.maxLoadingMeter,
            max_volume_liter: tour.maxVolumeLiter,
            max_volume_cubic_meter: tour.maxVolumeCubicMeter,
        },
        ...(stopList.some(stop => stop.chargingDraftId)
            ? { charging_drafts: stopList.filter(stop => stop.chargingDraftId).map(toChargingDraft) }
            : {}),
        stops: stopList.map((stop, i) => ({
            ...(stop.chargingDraftId ? { charging_draft_id: stop.chargingDraftId } : { order_id: stop.orderId }),
            type: stop.type === 'load' ? 'load' : stop.type === 'unload' ? 'unload' : 'execute',
            index: i,
            stop_update: stop.chargingDraftId ? undefined : stop.stopUpdate,
        })),
    };
};
